<template>
    <div :class="signUped?'horizontalScreen':'content'" type="false">
        <headers_m></headers_m>
        <div class="main">
            <div class="login_mobile" v-if="step1">
                <p class="toRegister1">{{$t('password').title}}</p>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <p>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('signUp').email.title}}</span>：
                        <input class="input" type="text" name="email" v-model="email" :placeholder="$t('signUp').email.placeholder">
                    </p>
                </div>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <div>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('password').code.title}}</span>：
                        <p class="inputS">
                            <input type="text" name="email" v-model="code" :placeholder="$t('password').code.placeholder">
                            <span class="code" @click="codes" style="letter-spacing: .5px;">{{getCode}}</span>
                        </p>
                    </div>
                </div>
                <p class="login_btn_m" @click="next">{{$t('signUp').btn}}</p>
            </div>

            <div class="login_mobile" v-if="step2">
                <p class="toRegister1">{{$t('password').title1}}</p>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <p>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('signUp').email.title}}</span>：
                        <input class="input" type="text" name="email" v-model="email" :placeholder="$t('signUp').email.placeholder">
                    </p>
                </div>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <div>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('password').code.title}}</span>：
                        <p class="inputS">
                            <input type="text" name="email" v-model="code_email" :placeholder="$t('password').code.placeholder">
                            <span class="code" v-show="showCount" @click="getCodess">{{getCodes}}</span>
                            <span v-show="!showCount" class="code">{{count}} s</span>
                        </p>
                    </div>
                </div>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <p>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('password').password.title}}</span>：
                        <input class="input" type="password" minlength="6" maxlength="12" name="password" v-model="password" :placeholder="$t('password').password.placeholder">
                    </p>
                </div>
                <div :class="$i18n.locale=='zh'?'register_flex_mobile':'register_flex_mobile_en'">
                    <p>
                        <span :class="$i18n.locale=='zh'?'span1':'span2'">{{$t('password').password1.title}}</span>：
                        <input class="input" type="password" minlength="6" maxlength="12" name="password" v-model="password1" :placeholder="$t('password').password1.placeholder">
                    </p>
                </div>
                <div class="btns">
                    <p class="login_btn_m" @click="submit" style="font-size:26px !important">{{$t('password').confirm}}</p>
                </div>
            </div>
        </div>
        <div class="footer">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
    import headers_m from "../components/headers_m.vue"
    export default {
        components: {
            headers_m
        },
        name: 'pcsignUp',
        data() {
            return {
                lang: "",
                email: "",
                getCode: this.randomString(6),
                code: "",
                code_email: "",
                getCodes: this.$t('password').btn,
                password: "",
                password1: "",
                toastShow: false,
                click: true,
                toastText: '',
                verify: /(\S)+[@]{1}(\S)+[.]{1}(\w)+/,
                step1: false,
                step2: true,
                token: localStorage.getItem("token"),
                signUped: true,
                count: '',
                timer: null,
                showCount: true,

            }
        },
        created() {
            let that = this;
            let lang = localStorage.getItem("lang");
            that.$i18n.locale = that.lang = lang;
            /* if (that.token == "" || that.token == null) {
                that.signUped = true
            } else {
                that.signUped = false
            } */
        },
        mounted() {

        },
        watch: {
            meeting_type() {
                this.cellphone = ""
                this.is_dine = "请选择"
            }
        },
        methods: {
            path(e) {
                let that = this,
                    path = e.target.dataset.path;
                that.$router.replace('/pc/' + path).catch(() => {})
            },
            codes() {
                this.getCode = this.randomString(6)
            },
            time() {
                let that = this;
                const time = 60;
                if (!that.timer) {
                    that.count = time;
                    that.showCount = false;
                    that.timer = setInterval(() => {
                        if (that.count > 0 && that.count <= time) {
                            that.count--;
                        } else {
                            that.showCount = true;
                            clearInterval(that.timer);
                            that.timer = null;
                        }
                    }, 1000)
                }
            },
            getCodess() {
                let that = this,
                    data = new FormData();
                if (that.email == "") {
                    that.toast(that.$t('signUp').email.placeholder)
                    return
                } else if (!(that.verify.test(that.email))) {
                    that.toast(that.$t('signUp').email.error)
                    return
                } else {
                    that.time();
                    data.append('event', "resetpwd");
                    data.append('email', that.email);
                    that.rq.post("/ems/send", data).then(res => {
                        if (res.code == "1") {
                            that.toast(that.$t('password').code.success)
                            localStorage.setItem("token", res.data.userinfo.token)
                            localStorage.setItem("user", res.data.userinfo)
                        } else if (res.code == "0") {
                            that.toast(that.$t('register').repeat)
                            return
                        }
                    })
                }

            },
            submit() {
                let that = this,
                    data = new FormData();
                if (that.click) {
                    that.click = false;
                    if (that.email == "") {
                        that.toast(that.$t('signUp').email.placeholder)
                        return
                    } else if (!(that.verify.test(that.email))) {
                        that.toast(that.$t('signUp').email.error)
                        return
                    } else if (that.code_email == "") {
                        that.toast(that.$t('password').code.placeholder)
                        return
                    } else if (that.code_email.length < 6) {
                        that.toast(that.$t('password').code.error)
                        return
                    } else if (that.password == "") {
                        that.toast(that.$t('signUp').password.placeholder)
                        return
                    } else if (that.password.length < 6) {
                        that.toast(that.$t('signUp').password.error)
                        return
                    } else if (that.password1 == "") {
                        that.toast(that.$t('signUp').password1.placeholder)
                        return
                    } else if (that.password == that.password1) {
                        data.append('email', that.email);
                        data.append('captcha', that.code_email);
                        data.append('newpassword', that.password);
                        data.append('type', "email");
                        that.rq.post("/user/resetpwd", data).then(res => {
                            if (res.code == "1") {
                                that.toast(that.$t('password').success)
                                setTimeout(() => {
                                    that.$router.replace('/login').catch(() => {})
                                }, 1400)
                            } else if (res.code == "0") {
                                that.toast(that.$t('register').repeat)
                                return
                            }
                        })
                    } else {
                        that.toast(that.$t('signUp').password1.error)
                        return
                    }
                }
            },
            toast(str) {
                let that = this
                that.toastText = str
                that.toastShow = true
                setTimeout(function() {
                    that.toastShow = false
                    that.click = true;
                }, 1500)
            },
            randomString(length) {
                var str = '0123456789abcdefghijklmnopqrstuvwxyz';
                var result = '';
                for (var i = length; i > 0; --i)
                    result += str[Math.floor(Math.random() * str.length)];
                return result.toLocaleUpperCase();
            }
        }
        ,
        updated(){
            this.getCodes = this.$t('password').btn
        }
    }
</script>
<style scoped>
    .success {
        width: 1000px;
        font-size: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .success img {
        width: 200px;
        height: 200px;
        margin: 0 auto 35px;
        display: inline-block;
    }
    
    .success_text {
        text-align: center;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(0deg, #FF6900 0%, #CC2200 100%);
        margin-bottom: 130px;
        font-size: 30px;
        font-weight: bold;
    }
    
    .success>p {
        width: 100%;
        color: #FF6900;
        line-height: 35px;
    }
    
    .btns {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
    }
    
    .btns>.login_btn_m {
        width: auto;
        min-width: 250px;
        padding: 0 25px;
        margin: 40px 20px;
    }
    
    .code {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
    }
    
    .inputS {
        width: 100%;
        height: 65px;
        /* background: #000000; */
        border-radius: 6px;
        font-size: 28px;
        color: #fff;
        display: flex;
        align-items: center;
        flex: 1;
    }
    
    .inputS>input {
        height: 100%;
        font-size: 28px;
    }
    
    .inputS>input:first-child {
        flex: 1;
        width: 100%;
        background: none;
        border: 1px solid #FF6900;
        border-radius: 6px;
        text-indent: 10px;
        color: #fff;
    }
    
    .code {
        height: 100%;
        width: 150px;
        background: #FF6900;
        margin-left: 19px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        line-height: 1;
        cursor: pointer;
    }
    
    .register_flex_mobile,
    .register_flex_mobile_en {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .register_flex_mobile>p,
    .register_flex_mobile_en>p {
        font-size: 26px;
        margin-bottom: 25px;
        display: flex;
        justify-content: center;
        width: 100%;
        align-items: center;
    }
    
    .register_flex_mobile>p>span,
    .register_flex_mobile>div>span,
    .register_flex_mobile_en>div>span,
    .register_flex_mobile_en>div>span {
        align-items: center;
        min-width: 120px;
        text-align: justify;
        display: inline-block;
        text-align-last: justify;
        height: 65px;
        line-height: 22px;
    }
    
    .register_flex_mobile>p>span::before,
    .register_flex_mobile>p>span::after,
    .register_flex_mobile>div>span::before,
    .register_flex_mobile>div>span::after,
    .register_flex_mobile_en>div>span::after,
    .register_flex_mobile_en>div>span::before {
        display: inline-block;
        content: '';
        width: 100%;
        height: 0;
        visibility: hidden;
    }
    
    .register_flex_mobile>p>span>i {
        display: block;
        width: 100%;
    }
    
    .register_flex_mobile_en>p>span {
        display: flex;
        text-transform:uppercase;
        justify-content: flex-end;
        align-items: center;
        /* min-width: 220px; */
    }
    
    .register_flex_mobile>div,
    .register_flex_mobile_en>div {
        width: 100%;
        font-size: 26px;
        margin-bottom: 25px;
        display: flex;
        justify-content: center;
        width: 100%;
        align-items: center;
    }
    
    .toRegister1 {
        padding-bottom: 30px;
    }
    
    .span2 {
        text-align: right!important;
        width: 230px;
        text-transform:uppercase;
    }
    
    .span1 {
        width: 100px;
    }
    /* <!-- text-align:$i18n.locale=='zh'?'':'right' */
    /*$i18n.locale=='zh'?'100px':'230px'--> */
</style>


// WEBPACK FOOTER //
// src/views/password.vue